module.exports = __webpack_public_path__ + "img/jsp.79811dd6.svg";